import { IWizTranslationEntry } from '@wizeoo/akm-core-lib';
import { LanguageVO } from '../../../vo/locale/language.vo';
import { TranslatedKeyPair } from '@wizeoo/akm-message-lib';
import { LocaleEngine } from '../../../manager/locale/locale.engine';
import { Model } from '../../../model/model';
import { AttachmentService } from '../../../command/core/attachment/attachment.service';
import { ViewData } from '../../../model/view.data';
import { Observable } from 'rxjs';

/**
 * VO de libellé traduit
 */
export class TranslatableLabelEntryVO implements IWizTranslationEntry {
  /**
   * Constructeur
   * @param pSource vo source du back
   */
  constructor(pSource?: TranslatedKeyPair) {
    this._source = pSource ? pSource : new TranslatedKeyPair();
  }

  /** Langue par défaut */
  public get defaultLanguage(): boolean {
    return this.languageCode === Model.getInstance().buLocaleCode;
  }

  /** Champ de tri : la langue par défaut prioritaire */
  private _sortField: string;
  public get sortField(): string {
    if (!this._sortField) {
      this._sortField = this.defaultLanguage ? '0_' : '1_';
      this._sortField += this.languageCode;
    }
    return this._sortField;
  }

  /**
   * Le vo source provenant du back
   */
  private _source: TranslatedKeyPair;
  public set source(value: TranslatedKeyPair) {
    this._source = value;
  }
  public get source(): TranslatedKeyPair {
    return this._source;
  }

  /** Code langue */
  public set languageCode(languageCode: string) {
    this._source.cod = languageCode;
  }
  public get languageCode(): string {
    return this._source.cod;
  }

  /** Libellé */
  public set label(label: string) {
    this._source.val = label;
  }
  public get label(): string {
    return this._source.val;
  }

  /* #############################################################
          accesseurs composites
     ############################################################# */

  /**
   * VO de la langue de cette traduction
   */
  private _languageVO: LanguageVO;
  public get languageVO(): LanguageVO {
    if (!this._languageVO) {
      this._languageVO = Model.getInstance().localeEngine.getLanguageByCode(this.languageCode);
    }
    return this._languageVO;
  }

  /** Icône de la langue */
  private _observeMe: Observable<string> = null;
  public get languageIcon(): Observable<string> {
    if (!this._observeMe) {
      this._observeMe = AttachmentService.getInstance().iconOrDie(this.languageVO.icon, ViewData.wildcardDomainLiteral, ViewData.wildcardDomainLiteral, ViewData.wildcardMainVision );
      // console.log('langV0', this.languageVO);
    }
    return this._observeMe;
  }

}
